// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-9e0c8a32]{font-size:.875rem;color:#6c757d;margin-bottom:.5rem}.settings-page[data-v-9e0c8a32]{width:100%}", ""]);
// Exports
module.exports = exports;
